import { Component, Vue } from "vue-property-decorator";

@Component<Example>({
  components: {}
})
export default class Example extends Vue {}
